
import React, { useEffect } from 'react'

/**
 * useClickOutside hook.
 */

export default function useClickOutside(ref, cb) {
  function click(e) {
    if (ref.current && !ref.current.contains(e.target)) {
      cb()
    }
  }

  useEffect(_ => {
    document.addEventListener('mouseup', click)
    return _ => {
      document.removeEventListener('mouseup', click)
    }
  }, [])
}